import { SettingsForm } from '@/components/settings/SettingsForm';
import '@/styles/dashboard.css';
import '@/styles/settings.css';

export const Parametres = () => {
  return (
    <>

    <SettingsForm />
  
    </>
  );
};

